export const PAGE_URLS = {
  view_dashboard: '/individual/individual_details.php?pageref=dashboard',
  my_fundraisers: '/individual/individual_details.php?pageref=campaigns',
  my_donations: '/individual/individual_details.php?pageref=donations',
  browse_fundraisers: '/campaign/campaign_listing.php',
  start_a_fundraiser: '/campaign/start_campaign.php',
  how_it_works: '/how_it_works/how-fundraising-works.php',
  get_us_on_whatsapp: 'https://api.whatsapp.com/send?phone=919930088522',
};
